import { client } from "../client";
import { unescapeChat, safeTags } from "../encoding";
import { getFilenameFromPath } from "../utils/paths";

// The category section a track gets appended under. AO music lists are a flat
// stream where a non-audio entry opens a new (collapsible) category and the
// audio entries that follow belong to it. Tracks seen before any category go
// straight into the list root.
let currentTracksContainer: HTMLElement | null = null;

const listRoot = () => document.getElementById("client_musiclist")!;

/** Reset per-room build state (call before (re)building the list). */
export const resetMusicTree = () => {
  currentTracksContainer = null;
};

/** Open a new collapsible category; following tracks nest under it. */
export const addMusicCategory = (rawName: string) => {
  const name = safeTags(unescapeChat(rawName));

  const header = document.createElement("div");
  header.className = "music-category";

  const caret = document.createElement("span");
  caret.className = "music-caret";
  caret.textContent = "\u25BE"; // ▾

  const label = document.createElement("span");
  label.className = "music-category-label";
  label.textContent = name || "\u2014";

  header.append(caret, label);

  const tracks = document.createElement("div");
  tracks.className = "music-tracks";

  header.onclick = () => {
    const collapsed = tracks.classList.toggle("collapsed");
    caret.textContent = collapsed ? "\u25B8" /* ▸ */ : "\u25BE" /* ▾ */;
  };

  listRoot().append(header, tracks);
  currentTracksContainer = tracks;
};

/** Append a playable track under the current category (or the root). */
export const addTrack = (trackname: string) => {
  const songName = getFilenameFromPath(trackname);

  const entry = document.createElement("div");
  entry.className = "music-track";
  entry.textContent = safeTags(unescapeChat(songName));
  entry.title = entry.textContent;
  entry.dataset.track = trackname;
  entry.onclick = () => client.sender.sendMusicChange(trackname);

  (currentTracksContainer || listRoot()).appendChild(entry);
  client.musics.push(trackname);
};
